import { Button, Grid  } from "@mui/material";
import React, { useState } from "react";
import WSIconCard from "../../Components/IconCard/WSIconCard";
import { WSIcons } from "../../commonFunctions/iIcons";
import bar from '../../Images/bar.png';
import { BarRightSidebar } from "./DineInRightSidebar";
import BarFooter from "./DineInFooter";
import { openPopUp } from "../../Components/Dialog/OpenNewModal";
import { IMetaData } from "../../Components/Dialog/WSCommonDialog";
import OrderInformation from "./OrderInformation";
import { NetLock } from "./NetLock";
import { SelectNotification } from "./SelectNotification";

export const Bar: React.FC<any> = React.memo((props) => {
  const [showAdditionalCards, setShowAdditionalCards] = useState(false);
  const [openLock,setOpenLock] = useState(false)
  const [openNotificationDialog, setOpenNotificationDialog] = useState(false);  

  const handleIconClick = () => {
    setShowAdditionalCards((prev) => !prev); // Toggle the visibility of additional cards
  };

  const handleClick = () => {
    openPopUp(metadata, handleData, "80rem");
  };
  const handleData = async (data: any) => {
    debugger;
    console.log("onsubmit===>", data); // You can perform any action with the submitted data here
  };
  const metadata: IMetaData = {
    title: " Order Information",
    hideActions: false,
    content: (props: any, row: any) => (
      <OrderInformation {...props}  />
    ),
    actions: [
      
      {
        label: "Finish",
        onClick: handleData,
        type: "submit",
        autoFocus: true,
      },
    ],
    isDragable: true,
  };
 /**
   * Lock
   */
 const handleLockClick=()=>{
  setOpenLock(true)
}

const handleLockClose = ()=>{
  setOpenLock(false)
}
  /**
 * Notification Dialogue
 */
  const handleNotificationClick = () => {            
    setOpenNotificationDialog(true); 
  };

  const handleNotificationClose = () => {
    setOpenNotificationDialog(false); 
  };


  return (
    <Grid container spacing={3} sx={{  overflow: "hidden", maxWidth: "100vw" }}>
      {/* Left Sidebar */}
      <Grid item xs={12} sm={1} sx={{ mt: 1 }}>
        <Grid container direction="column" spacing={2}>
          {/* Your icon cards here... */}
          <Grid item>
            <WSIconCard
              icon={
                <WSIcons.KeyboardArrowLeftIcon sx={{ alignItems: "center", fontSize: '2rem', color: 'white' }} />
              }
              sx={{ height: "5rem", width: "6rem", backgroundColor: 'green' }}
              onClick={handleIconClick} // Add click handler
            />
          </Grid>
          <Grid item>
              <WSIconCard
                icon={<WSIcons.EditNoteIcon sx={{ alignItems: "center", fontSize: '2rem' }} />}
                sx={{ height: "5rem", width: "6rem" }}
              />
            </Grid>
            <Grid item>
              <WSIconCard
                icon={<WSIcons.Person sx={{ alignItems: "center", fontSize: '2rem' }} />}
                sx={{ height: "5rem", width: "6rem" }}
              />
            </Grid>
            <Grid item>
              <WSIconCard
                icon={<WSIcons.LockIcon sx={{ alignItems: "center", fontSize: '2rem' }} />}
                sx={{ height: "5rem", width: "6rem" }}
                onClick={handleLockClick}
              />
            </Grid>
            <NetLock open={openLock} onClose={handleLockClose}/>
            <Grid item>
              <WSIconCard
                icon={<WSIcons.AlarmIcon sx={{ alignItems: "center", fontSize: '2rem' }} />}
                sx={{ height: "5rem", width: "6rem" }}
              />
            </Grid>
            <Grid item>
              <WSIconCard
                icon={<WSIcons.TableRestaurantIcon sx={{ alignItems: "center", fontSize: '2rem' }} />}
                sx={{ height: "5rem", width: "6rem" }}
              />
            </Grid>
            <Grid item>
              <WSIconCard
                icon={<WSIcons.NotificationsIcon sx={{ alignItems: "center", fontSize: '2rem' }} />}
                sx={{ height: "5rem", width: "6rem" }}
                onClick={handleNotificationClick}
              />
            </Grid>
            <SelectNotification open={openNotificationDialog} onClose={handleNotificationClose}/>

            <Grid item>
              <WSIconCard
                icon={<WSIcons.RoomServiceIcon sx={{ alignItems: "center", fontSize: '2rem' }} />}
                sx={{ height: "5rem", width: "6rem" }}
              />
            </Grid>
            <Grid item>
              <WSIconCard
                icon={<WSIcons.SyncIcon sx={{ alignItems: "center", fontSize: '2rem' }} />}
                sx={{ height: "5rem", width: "6rem" }}
              />
            </Grid>
            </Grid>
      </Grid>

      {/* Main Content Area */}
      <Grid item xs={12} sm={7} sx={{ position: "relative", overflow: "hidden" }}>
        <Grid sx={{ maxWidth: "100%", overflow: "hidden" }}>
          <img src={bar} alt="Bar" style={{ width: '100%', height: '54rem' }} />
          <Grid container spacing={2} sx={{ 
              position: "absolute", 
              top: "5rem", 
              left: "10", // Positioning to the right of the image
              transform: 'translateY(-50%)', 
              marginLeft: '10px' // Add some margin to the left
            }}>
            <Grid item sm={2}>
  <Button
    sx={{
      height: "4rem", 
      backgroundColor: 'lightblue', // Set a background color
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  onClick={handleClick}
  >
  1
  </Button>
</Grid>

            </Grid>
        </Grid>

        {/* Conditional Rendering of Additional Icon Cards */}
        {showAdditionalCards && (
          <Grid container spacing={2} sx={{ 
              position: "absolute", 
              top: "5rem", 
              left: "10", // Positioning to the right of the image
              transform: 'translateY(-50%)', 
              marginLeft: '10px' // Add some margin to the left
            }}>
            <Grid item>
              <WSIconCard
                icon={<WSIcons.TableRestaurantIcon sx={{ alignItems: "center", fontSize: '2rem' }} />}
                sx={{ height: "5rem", width: "6rem" }}
              />
            </Grid>
            <Grid item>
              <WSIconCard
                icon={<WSIcons.TableRestaurantIcon sx={{ alignItems: "center", fontSize: '2rem' }} />}
                sx={{ height: "5rem", width: "6rem" }}
              />
            </Grid>
            <Grid item>
              <WSIconCard
                icon={<WSIcons.TableRestaurantIcon sx={{ alignItems: "center", fontSize: '2rem' }} />}
                sx={{ height: "5rem", width: "6rem" }}
              />
            </Grid>
          </Grid>
        )}
      </Grid>

      {/* Right Sidebar */}
      <Grid item xs={12} sm={4} sx={{  height: '100vh' }}>
        <BarRightSidebar/>
      </Grid>
      <Grid item xs={12}>
        <BarFooter/>
      </Grid>
    </Grid>
  );
});
